import Group from './group';
import User from './user';
import { EVENT_USER_STATUS_DATA, SUBORDINATION_TRANSFER_STATUS_DATA } from '@/modules/Events/constants';

// NOTE: СМОТРИМ СТАТУС ПО ЗАЯВКЕ (ПОТОМ ПЕРЕДЕЛАТЬ)
const getStatus = (participant) => {
  if (participant.status) {
    return EVENT_USER_STATUS_DATA[participant.status];
  }
  if (participant.request) {
    const [request] = participant.request || [];
    if (request?.status) {
      // TODO: Возможно стоит возращать корректный статус у юзера сразу с бэка
      // Получаю статусы по заявке, возвращаю статусы юзера
      const requestStatusData = SUBORDINATION_TRANSFER_STATUS_DATA[request.status];

      return EVENT_USER_STATUS_DATA[requestStatusData.userStatus];
    }
  }

  return null;
};

export default class Participant extends User {
  constructor(participant, url) {
    super(participant, url);

    this.certificate = {
      certificate_number: '-',
      ...(participant.certificate || {}),
    };
    this.directory_attributes = {
      grade: '-', // Тут оно не так работает, у нас @directory_attributes - это массив
      ...(participant.directory_attributes || {}),
    };
    this.status = getStatus(participant);
    [this.request] = participant.request || [];
    this.organizer = participant.organizer || null;
    this.subordination_id = participant.subordination_id || null;
    this.prize_places = participant.prize_places || null;
    this.subordinations = participant.subordinations || [];
    this.user_requests = participant.user_requests || [];
    this.transferActions = [];
    this.is_imported = participant.is_imported || false;
    this.import_id = participant.import_id || null;

    this.nomination_id = participant.nomination_id || null;
    this.event_groups = [participant.event_groups].flat().filter(Boolean).map((group) => new Group(group));
    this.groups = [participant.groups].flat().filter(Boolean).map((group) => new Group(group));
  }

  initTransferActions(actions) {
    this.transferActions = actions || [];
  }
}
